<template>
  <div class="h-screen flex w-full bg-img p-fix vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 login-max-w sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color back-grey">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden xl:block lg:w-1/2 px-4 py-10 color-bg-login min-h-login">
              <img class="mb-5 max-w-logo d-block m-auto" src="@/assets/images/logo/logo-full.svg" alt="registerImg">
              <img src="@/assets/images/pages/success.svg" alt="login" class="mx-auto">
            </div>

            <div class="vx-col md:w-full lg:w-full xl:w-1/2 xl d-theme-dark-bg">

              <div class="p-8 lg:mt-5 login-tabs-container py-login min-h-tax">
                <div class="vx-card__title mb-3">
                  <h4 class="mb-4">¡Estamos casi listos!</h4>
                  <p>Por favor captura tus datos fiscales, quizá los necesitemos más adelante si decides realizar alguna compra de firmas o planes de servicio.</p>
                </div>

                <div>

                  <div class="vx-row pb-6">
                    <div class="vx-col w-full ">
                      <vs-input
                        label-placeholder="Nombre o Razón Social"
                        name="razon_social"
                        autocomplete="off"
                        placeholder="Nombre o Razón Social"
                        v-model="razon_social"
                        @input="razon_social = $event.toUpperCase()"
                        class="w-full" />
                    </div>

                    <div class="vx-col w-full ">
                      <vs-input
                        label-placeholder="RFC (opcional)"
                        name="rfc"
                        autocomplete="off"
                        placeholder="RFC"
                        v-model="rfc"
                        v-facade="['AAA-######-XXX', 'AAAA-######-XXX']"
                        v-on:input.native="getRfcUnmasked"
                        @input="rfc = $event.toUpperCase()"
                        class="w-full" />
                    </div>

                    <div class="vx-col w-full ">
                      <label class="vs-input--label">Uso de CFDI</label>
                      <v-select :options="cfdiList" v-model="dataCfdiUse" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </div>
                  </div>

                  <div class="upload-img mt-2">
                    <vs-button class="mb-4" :disabled="isSubmitted" @click="submitForm">Guardar</vs-button>
                    <vs-button  type="flat" class="float-right" @click="skip" >Omitir</vs-button>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import router from "../../../../router";
import vSelect from 'vue-select'

export default {
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      cfdiList: [
        {id: 'G01', label: 'G01 - Adquisición de mercancias'},
        {id: 'G02', label: 'G02 - Devoluciones, descuentos o bonificaciones'},
        {id: 'G03', label: 'G03 - Gastos en general'},
        {id: 'I01', label: 'I01 - Construcciones'},
        {id: 'I02', label: 'I02 - Mobilario y equipo de oficina por inversiones'},
        {id: 'I03', label: 'I03 - Equipo de transporte'},
        {id: 'I04', label: 'I04 - Equipo de computo y accesorios'},
        {id: 'I05', label: 'I05 - Dados, troqueles, moldes, matrices y herramental'},
        {id: 'I06', label: 'I06 - Comunicaciones telefónicas'},
        {id: 'I07', label: 'I07 - Comunicaciones satelitales'},
        {id: 'I08', label: 'I08 - Otra maquinaria y equipo'},
        {id: 'D01', label: 'D01 - Honorarios médicos, dentales y gastos hospitalarios.'},
        {id: 'D02', label: 'D02 - Gastos médicos por incapacidad o discapacidad'},
        {id: 'D03', label: 'D03 - Gastos funerales'},
        {id: 'D04', label: 'D04 - Donativos'},
        {id: 'D06', label: 'D06 - Aportaciones voluntarias al SAR'},
        {id: 'D07', label: 'D07 - Primas por seguros de gastos médicos'},
        {id: 'D08', label: 'D08 - Gastos de transportación escolar obligatoria'},
        {id: 'D09', label: 'D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.'},
        {id: 'D10', label: 'D10 - Pagos por servicios educativos (colegiaturas)'},
        {id: 'P01', label: 'P01 - Por definir'}
      ],
      dataCfdiUse: null,
      popupActive: false,
      razon_social: null,
      rfc: null,
      isSubmitted: false,
      unmaskedRfc: ""
    }
  },
  methods: {
    getRfcUnmasked(e) {
      this.unmaskedRfc = e.target.unmaskedValue;
    },
    skip() {
      let user = JSON.parse(localStorage.getItem("user"));
      user['config'] = {
        taxDataSkipped: true
      }
      localStorage.setItem("user", JSON.stringify(user));
      setTimeout(() => {
        router.push("/");
      }, 100)
    },
    submitForm() {
      this.$store.dispatch("alert/clear", {}, {root:true});
      if (!this.razon_social || !this.unmaskedRfc || !this.dataCfdiUse) {
        this.$store.dispatch("alert/error", "Ingresa los datos solicitados", {root: true});
        return;
      }
      this.isSubmitted = true;
      this.$store.dispatch('taxData/createTaxData', {
        taxData: {
          company: this.razon_social,
          rfc: this.unmaskedRfc,
          use_cfdi: this.dataCfdiUse.id,
          default: true,
        }
      })
      .then(() => {
          this.$store.dispatch("account/me", {}).then(
            () => {
              this.isSubmitted = false;
              setTimeout(() => {
                router.push("/");
              }, 100)
            },
            error => {
              this.$store.dispatch("alert/error", "Hubo un problema con la obtención de sus datos, ingrese de nuevo a su cuenta");
              this.isSubmitted = false;
              setTimeout(() => {
                router.push("/login");
              }, 100)
            }
          )
        },
        error => this.isSubmitted = false
      )
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.p-fix{
  position: fixed;
}
</style>
